module.exports = __webpack_public_path__ + "img/soft-grove-study-1.408d0210.jpeg";